import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import AccountAx          from 'app/actions/account';
import Icon               from 'app/components/common/icon';
import UploadedImageInput from 'app/components/common/uploaded-image-input';
import cdn                from 'app/helpers/cdn';
import AccountSlx         from 'app/selectors/account';
import AuthSlx            from 'app/selectors/auth';



class EditableAvatar extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      inputPending: false,
    };

    this.refInput = React.createRef();

    this.onClick = this.onClick.bind(this);
    this.onChangeAvatar = this.onChangeAvatar.bind(this);
    this.onChangeInputPending = this.onChangeInputPending.bind(this);
  }

  onClick() {
    this.refInput.current.open();
  }

  onChangeAvatar(avatarPath) {
    this.props.update(avatarPath);
  }

  onChangeInputPending(inputPending) {
    this.setState({inputPending});
  }

  render() {
    const {user, isUploading, size, className} = this.props;
    const {inputPending} = this.state;
    const isPending = isUploading || inputPending;
    if (!user) return null;
    const src = user.avatarUrl ? cdn.imgUrl(user.avatarUrl, {width: (size * 2), height: (size * 2), fit: 'cover'}) : null;
    const hasImg = !!src;
    const uploadingClass = isPending ? 'uploading' : '';
    const OverlayIcon = isPending ? Icon.Loading : Icon.Pencil;

    return (
      <div className={`edit-avatar size-${size} ${uploadingClass} ${className}`} onClick={this.onClick}>
        {hasImg ? (<>
          <img className="edit-avatar-img" src={src} />
        </>) : (<>
          <Icon.ImageFileAdd className="edit-avatar-add-icon" />
        </>)}
        <div className="edit-avatar-overlay">
          <OverlayIcon className="edit-avatar-overlay-icon" />
        </div>

        <UploadedImageInput ref={this.refInput} onChange={this.onChangeAvatar} className="edit-avatar-input" onChangeLoading={this.onChangeInputPending} />
      </div>
    );
  }

}

EditableAvatar.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};
EditableAvatar.defaultProps = {
  size: 60,
  className: '',
};

const stateToProps = (state) => ({
  user: AuthSlx.currentUser(state),
  isUploading: AccountSlx.updatingAccount(state),
});

const dispatchToProps = (dispatch) => ({
  update: (avatarPath) => dispatch(AccountAx.update({avatarPath})),
});

export default connect(stateToProps, dispatchToProps)(EditableAvatar);
